export default __webpack_public_path__ + "static/media/mail.31233b5f.svg";